module.exports = __webpack_public_path__ + "fonts/Colfax-Black.ea153112.otf";